import { getSession, type SessionData } from './session';
import { queryClient } from './reactQueryClient';
const empty: SessionData = { token: null, user: null };
let key: string | undefined;
let snapshot = empty;
export function getSessionSnapshot(): SessionData {
  if (typeof window === 'undefined') return empty;
  let next: string;
  try { next = (localStorage.getItem('jwt') ?? '') + '\0' + (localStorage.getItem('session_user') ?? ''); }
  catch { return empty; }
  if (next !== key) { key = next; snapshot = getSession(); }
  return snapshot;
}
export function subscribeSession(notify: () => void) {
  const storage = (event: StorageEvent) => {
    if (!event.key || event.key === 'jwt' || event.key === 'session_user') { queryClient.clear(); notify(); }
  };
  window.addEventListener('storage', storage);
  window.addEventListener('kora:session', notify);
  return () => { window.removeEventListener('storage', storage); window.removeEventListener('kora:session', notify); };
}
export const getServerSession = () => empty;
